module.exports = __webpack_public_path__ + "static/media/1_4park.184152bb.jpg";